<template>
   <page-container>
    <template v-slot:page-fixed-header>
      <span class="text-h5 font-weight-bold ml-3 full-width page-header">{{ $t("menu.aboutus") }}</span>
      <v-spacer></v-spacer>
    </template>
        <template v-slot:page-content>

      <v-row justify="center">
        <v-col cols="12">      
            <LandingPage />      
        </v-col>
      </v-row>         
 
        </template>
   </page-container>
</template>

<script>
// @ is an alias to /src
import LandingPage from '@/components/LandingView.vue'

export default {
  name: 'About',
  components: {
    LandingPage
  }
}
</script>

<style scoped>
::v-deep .container--fluid {
  padding:0px !important;
}

</style>